// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"8b4a4556","98":"f5e79284","219":"db027182","448":"47f47d8b","580":"2ee5eff6","584":"0850381c","846":"2a0af0be"}[chunkId] + ".chunk.js";
};